// Davr chegaralarini EKRANDA ko'rsatish.
//
// =====================================================================
// ⚠️ `endsOn` — CHEGARADAN TASHQARI (exclusive)
// =====================================================================
// Avgust davri uchun server `startsOn = 2026-08-01`, `endsOn =
// 2026-09-01` beradi. Buni o'z holicha chizish "avgust 1-sentyabrgacha
// davom etadi" degan yolg'on bo'lardi va operator 1-sentyabr xarajatini
// avgustga yozishga urinardi.
//
// Sabab backendda yozilgan va u to'g'ri: `atEndOfMonth()` (31-avgust)
// ishlatilsa, "oxirgi kunning O'ZI davrga kiradimi" degan savol har
// so'rovda qaytadan hal qilinardi — bir joyda `<=`, boshqasida `<` va
// natijada bitta kun ikki davrga tushardi yoki umuman tushmasdi.
//
// Ya'ni SHARTNOMA to'g'ri, faqat u ODAM O'QIYDIGAN shaklga bir joyda
// o'giriladi — shu faylda.
//
// =====================================================================
// ⚠️ SANA VAQT ZONASIDAN O'TKAZILMAYDI
// =====================================================================
// `startsOn`/`endsOn` — `LocalDate` (kalendar kuni), lahza EMAS.
// `shared/lib/format.ts` dagi `formatDate` uni `new Date(...)` bilan
// UTC yarim tunga aylantirib, keyin ko'rsatish zonasiga o'tkazadi —
// manfiy siljishli zonada bu KUNNI BIR KUN ORQAGA surardi. Bu yerda
// hech qanday konvertatsiya yo'q: kun qanday kelgan bo'lsa shunday
// ko'rsatiladi.
//
// Aniq lahzalar (`startsAt`/`endsAt`) esa ALOHIDA ko'rsatiladi va ular
// zona bilan formatlanadi — `Asia/Kabul` = UTC+4:30 va avgust
// `2026-07-31T19:30:00Z` da boshlanadi.

import dayjs from 'dayjs'
import type { Period } from './financeApi'

/**
 * Davrning OXIRGI KUNI (inclusive) — `endsOn` dan bir kun oldin.
 *
 * @returns `YYYY-MM-DD`
 */
export function periodLastDay(period: Period): string {
  return dayjs(period.endsOn).subtract(1, 'day').format('YYYY-MM-DD')
}

/** "2026-08-01 — 2026-08-31" */
export function periodRangeLabel(period: Period): string {
  return `${period.startsOn} — ${periodLastDay(period)}`
}

/**
 * Berilgan KUN qaysi davrga tushadi.
 *
 * ⚠️ Server bu savolga BOSHQACHA javob beradi: u kunni tenant zonasida
 * lahzaga aylantirib, `starts_at <= lahza < ends_at` ni tekshiradi
 * (`ExpenseServiceImpl`). Natija AYNAN BIR XIL, chunki chegaralar
 * o'sha zonada, o'sha kunlardan hisoblangan — ya'ni bu yerdagi oddiy
 * sana solishtiruvi serverning qaroriga zid kelmaydi.
 *
 * ⚠️ Panel bu javobni SERVERGA YUBORMAYDI: davrni klient tanlasa,
 * avgustga tegishli xarajatni sentyabrga yozib qo'yish mumkin bo'lardi
 * (`ExpenseServiceImpl` javadoc'i). Bu yerdagi hisob faqat OGOHLANTIRISH
 * uchun — "bu sana uchun ochiq davr yo'q".
 *
 * @param date `YYYY-MM-DD`
 */
export function periodForDate(
  periods: readonly Period[],
  date: string,
): Period | null {
  // ISO sanalarni satr sifatida solishtirish to'g'ri: shakl qat'iy
  // (`YYYY-MM-DD`) va leksikografik tartib xronologik tartib bilan mos.
  return periods.find((period) => period.startsOn <= date && date < period.endsOn) ?? null
}
